import { Component, inject, Input, OnInit } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { CodaltComponent } from 'src/app/codalt.component';
import { ApiService } from 'src/app/services/api/api.service';

interface AuthSession {
    id: number;
    uuid: string;
    type: string;
    session_type: 'regular' | 'impersonation' | 'temporary';
    device_type: string;
    device_name: string | null;
    latest_location: string | null;
    latest_municipality: string | null;
    created_at: string;
    last_activity_at: string | null;
    expires_at: string | null;
    revoked_at: string | null;
    impersonated_by: { id: number; name: string } | null;
    is_current: boolean;
}

/**
 * Sessions of a user, or of the logged in user when no userId is given.
 */
@Component({
    selector: 'app-user-auth-sessions',
    standalone: false,
    templateUrl: './user-auth-sessions.component.html',
})
export class UserAuthSessionsComponent extends CodaltComponent implements OnInit {
    private apiService = inject(ApiService);

    @Input() userId?: number;

    loading = true;
    sessions: AuthSession[] = [];

    ngOnInit() {
        this.subscriptions.add(
            this.apiService
                .getCallData$<AuthSession[]>(this.userId ? `users/${this.userId}/auth-sessions` : 'auth/me/sessions')
                .pipe(finalize(() => (this.loading = false)))
                .subscribe(sessions => (this.sessions = sessions))
        );
    }

    status(session: AuthSession): 'Actief' | 'Ingetrokken' | 'Verlopen' {
        if (session.revoked_at) {
            return 'Ingetrokken';
        }
        return session.expires_at && new Date(session.expires_at) <= new Date() ? 'Verlopen' : 'Actief';
    }
}
